import ReactDOM from 'react-dom'

export * from './config'

export default class Fishx {
  static config: any = {
    root: '#root'
  }

  static history: any = {

  }

  static updateConfig(partialConfig: object) {
    Fishx.config = {
      ...Fishx.config,
      ...partialConfig,
    }
  }

  static updateHistory(history: object) {
    Fishx.history = history;
  }

  static async bootstrap(element: any, root = '#root') {
    ReactDOM[(window as any).__FISHX_SSR_ENABLED__ ? 'hydrate' : 'render'](element, document.querySelector(root))
  }

  static integrate(element: any) {
    return function (selector: any) {
      ReactDOM.render(element, document.querySelector(selector))
    }
  }

  static unmount(selector: any = '#root') {
    ReactDOM.unmountComponentAtNode(document.querySelector(selector));
  }
}
